import bangkok from '../assets/images/featured_home/bangkok.png';
import sydney from '../assets/images/featured_home/sydney.png';
import newyork from '../assets/images/featured_home/newyork.png';

import hotels from '../assets/images/property_list/hotels.png';
import villas from '../assets/images/property_list/villas.png';
import resorts from '../assets/images/property_list/resorts.png';
import cabins from '../assets/images/property_list/cabins.png';
import cottages from '../assets/images/property_list/cottages.png';


import miasto from '../assets/images/loved_prop/miasto.png';

export const featuredItemList = [
    {
        name: "Bangkok",
        properties: 123,
        imageSrc: bangkok
    },
    {
        name: "Newyork",
        properties: 342,
        imageSrc: newyork
    },
    {
        name: "Sydney",
        properties: 178,
        imageSrc: sydney
    }
];

export const propertyTypes = [
    {
        name: "Hotel",
        properties: "1,356",
        imageSrc: hotels
    },
    {
        name: "villa",
        properties: "234",
        imageSrc: villas
    },
    {
        name: "resort",
        properties: "1,216",
        imageSrc: resorts
    },
    {
        name: "cabin",
        properties: "344",
        imageSrc: cabins
    },
    {
        name: "cottage",
        properties: "56",
        imageSrc: cottages
    },
];

export const lovedProp = [
    {
        name: "ApartHotel Stare Miasto",
        location: "Madrid",
        startPrice: 120,
        rating: 8.9,
        imageSrc: miasto
    },
    {
        name: "ApartHotel Stare Miasto",
        location: "Madrid",
        startPrice: 120,
        rating: 8.9,
        imageSrc: miasto
    },
    {
        name: "ApartHotel Stare Miasto",
        location: "Madrid",
        startPrice: 120,
        rating: 8.9,
        imageSrc: miasto
    },
    {
        name: "ApartHotel Stare Miasto",
        location: "Madrid",
        startPrice: 120,
        rating: 8.9,
        imageSrc: miasto
    },
];

export const footerData = [
    [
        "Countries",
        "Regions",
        "Cities",
        "Districts",
        "Airports",
        "Hotels",
        "Places of interest"
    ],
    [
    "Homes",
    "Apartments",
    "Resorts",
    "Villas",
    "Hostels",
    "B&Bs",
    "Guest houses"
    ],
    [
        "Unique places to stay",
        "All destinations",
        "All flight destinations",
        "Discover",
        "Reviews",
        "Discover monthly stays",
        "Unpacked: Travel articles",
        "Travel Communities",
        "Seasonal and holiday deals",
        "Traveller Review Awards"
    ],
    [
    "Car hire",
    "Flight finder",
    "Restaurant reservations",
    "Booking.com for Travel Agents"
    ]
    
]